import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { createPortal } from "react-dom";
import { ContentType, HomepageSectionType, Orientation, } from "../../types/global";
import CategoriesSwiper from "../homepage/CategoriesSwiper";
import GenericButton from "../helpers/GenericButton";
import SearchLayerSectionSwiper from "./SearchLayerSectionSwiper";
import useTailwindBreakpoint from "../../hooks/useTailwindBreakpoint";
export default function SearchLayer({ data, ref, onReachEnd, onClose }) {
    const isLg = useTailwindBreakpoint("lg");
    const { t } = useTranslation();
    React.useEffect(() => {
        document.body.classList.add("overflow-hidden");
        return () => {
            document.body.classList.remove("overflow-hidden");
        };
    }, []);
    const landscapeContents = data?.content_list?.flatMap((item) => {
        if (item.type === ContentType.Folder)
            return [];
        const contentList = item.content_list;
        return (contentList?.filter((contentItem) => {
            const info = typeof contentItem.info === "string"
                ? JSON.parse(contentItem.info)
                : contentItem.info;
            return info?.is_vod_vertical === Orientation.Landscape;
        }) ?? []);
    }) ?? [];
    const portraitContents = data?.content_list?.flatMap((item) => {
        const contentList = item.content_list;
        switch (item.type) {
            case ContentType.Folder: {
                return [];
            }
            case ContentType.Shorts:
            case ContentType.Reels: {
                return contentList;
            }
            default: {
                return (contentList?.filter((contentItem) => {
                    const info = typeof contentItem.info === "string"
                        ? JSON.parse(contentItem.info)
                        : contentItem.info;
                    return info?.is_vod_vertical === Orientation.Portrait;
                }) ?? []);
            }
        }
    }) ?? [];
    const catalogueContents = data?.content_list?.filter((item) => item.type === ContentType.Folder)[0]
        ?.content_list ?? [];
    const catalogueSection = {
        type: HomepageSectionType.Categories,
        title: "",
        cover_orientation: Orientation.Landscape,
        content_list: catalogueContents,
    };
    return createPortal(_jsxs("div", { ref: ref, className: `supports-backdrop-filter:bg-background/60 pointer-events-auto fixed inset-0 z-49 min-h-screen min-w-screen overflow-x-hidden overflow-y-scroll py-10 backdrop-blur-lg **:no-underline md:py-16`, children: [_jsxs("div", { className: "mx-5 mt-4 flex flex-row items-center justify-between md:mx-10", children: [_jsx("div", { className: "text-generic text-xl", children: catalogueContents.length === 0 &&
                            landscapeContents.length === 0 &&
                            portraitContents.length === 0 &&
                            t("no-results") }), _jsx("div", { onClick: onClose, children: _jsx(GenericButton, { variant: "close", size: isLg ? "md" : "sm", icon: true }) })] }), _jsxs("div", { className: "mt-6 ml-3 flex flex-col gap-2 md:mt-8 md:ml-18 md:gap-4", children: [catalogueContents.length > 0 && (_jsx(CategoriesSwiper, { data: catalogueSection, allowShowAll: false, loadOnEnd: false, navigation: {
                            prevPosition: "left-0 -translate-x-1/2",
                            nextPosition: "right-6",
                        }, onReachEnd: onReachEnd, isSearchSection: true })), landscapeContents.length > 0 && (_jsx(SearchLayerSectionSwiper, { data: landscapeContents, slideOrientation: Orientation.Landscape, onReachEnd: onReachEnd })), portraitContents.length > 0 && (_jsx(SearchLayerSectionSwiper, { data: portraitContents, slideOrientation: Orientation.Portrait, onReachEnd: onReachEnd }))] })] }), document.body);
}
